<mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-bar-container" cdk-overlay-origin #overlayPosition="cdkOverlayOrigin">
    <input matInput [formControl]="control" placeholder="Address line 1" class="input" (click)="overlayOpen.set(true)">
</mat-form-field>

<ng-template cdk-connected-overlay 
             [cdkConnectedOverlayOrigin]="overlayPosition" 
             [cdkConnectedOverlayOpen]="overlayOpen()"
             (overlayOutsideClick)="overlayOpen.set(false)">
    <section class="overlay-container">
        <app-search-overlay class="search-overlay" (searchSelection)="updateForm($event)"></app-search-overlay>
    </section>
</ng-template>
